import React, { useState } from 'react';
import { ColorValue, Image, View } from 'react-native';
import { TabBarIcon } from './tab-bar-icon';

interface ProfileTabIconProps {
  color: ColorValue;
  focused: boolean;
  avatarUrl?: string;
  size?: number;
}

export function ProfileTabIcon({
  color,
  focused,
  avatarUrl,
  size = 28
}: ProfileTabIconProps) {
  const [imageError, setImageError] = useState(false);

  // If no avatar URL is provided or image failed to load, show the default icon
  if (!avatarUrl || imageError) {
    return (
      <TabBarIcon
        name={focused ? 'person-circle' : 'person-circle-outline'}
        color={color}
        size={size}
      />
    );
  }

  // Show the profile avatar with a thin border
  return (
    <View
      style={{
        width: size,
        height: size,
        overflow: 'hidden',
        backgroundColor: 'transparent', // Ensure border is visible even with transparent images
      }}
    >
      <Image
        source={{ uri: avatarUrl }}
        style={{
          width: '100%',
          height: '100%',
          borderRadius: size / 2,
        }}
        resizeMode="cover"
        onError={() => setImageError(true)}
        accessible={false}
      />
    </View>
  );
}
